import { Phone, FileText } from "lucide-react";

export const MobileCTA = () => (
  <div
    data-testid="mobile-cta-bar"
    className="fixed bottom-0 z-50 flex w-full border-t-2 border-gold bg-ink lg:hidden"
  >
    <a
      href="tel:4706840150"
      data-testid="mobile-bar-call"
      className="flex flex-1 items-center justify-center gap-2 bg-gold py-4 font-heading text-xl uppercase tracking-wide text-ink active:bg-gold-light"
    >
      <Phone size={17} /> Call Now
    </a>
    <a
      href="#contact"
      data-testid="mobile-bar-quote"
      className="flex flex-1 items-center justify-center gap-2 py-4 font-heading text-xl uppercase tracking-wide text-gold active:bg-coal"
    >
      <FileText size={17} /> Get Free Quote
    </a>
  </div>
);
